import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

// import p1 from 'assests/Photos/Events/shikar/1.jpg';
// import p2 from 'assests/Photos/Events/shikar/2.jpg';

// import p3 from 'assests/Photos/Events/shikar/3.jpg';
// import p4 from 'assests/Photos/Events/shikar/4.jpg';
// import p5 from 'assests/Photos/Events/shikar/5.jpg';
// import p6 from 'assests/Photos/Events/shikar/6.jpg';
// import p7 from 'assests/Photos/Events/shikar/7.jpg';
// import p8 from 'assests/Photos/Events/shikar/8.jpg';
// import p9 from 'assests/Photos/Events/shikar/9.jpg';
import Ph1 from './Ph1';
import Ph2 from './Ph2';
import Ph3 from './Ph3';
import Ph4 from './Ph4';

import SideBarT from './SideBarT';

import LifeSideBar from 'views/LifeSkill/components/LifeSideBar';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import SidebarArticles from 'views/ClassAssembly3E/components/SidebarArticles/SidebarArticles';
// import { Roadsafety } from 'views';

const Shikar2022 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [config, setConfig] = useState({ base_image_url: '' });
  useEffect(() => {
  fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
    .then(response => response.json())
    .then(data => setConfig(data))
    .catch(error => console.error('Error fetching config:', error));
}, []);

const p1 = `${config.base_image_url}/home/home-static/events/shikar/1.webp`;
const p2 = `${config.base_image_url}/home/home-static/events/shikar/2.webp`;


  const photos = [
    {
      src: p1,
      source: p1,
      rows: 1,
      cols: 1,
    },
    {
      src: p2,
      source: p2,
      rows: 1,
      cols: 1,
    },
  
     
   


    // {
    //   src: 'https://assets.maccarianagency.com/backgrounds/img21.jpg',
    //   source: 'https://assets.maccarianagency.com/backgrounds/img21.jpg',
    //   rows: 1,
    //   cols: 1,
    // },
  ];

  return (
    <Main>
        <Container>
    <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
    <Box>
        
      <Box >
      <Typography variant='h4' align='center'>
      SHIKHAR 2022 
        </Typography>
        <Typography
        fontSize = "x-small"
        ><br/><br/>
        Class 1-12 21.12.2022 & 22.12.2022 
        </Typography>

        <br />
        <Typography variant={'subtitle1'} align={'center'}>
       <i> If there is one field of life which teaches us the most valuable lessons about perseverance,
patience and in fact what constitutes a perfect character, it is sports.</i>
        </Typography>
        <Typography variant={'subtitle1'} align={'justify'}>

In addition to inspiring young minds, sports also imparts moral principles and ethics to
young students. Sports indeed is a celebration of the human spirit and youth. 
<br/>
<br></br>
National Public School Yeshwanthpur celebrated its Annual Sports Day SHIKHAR 2022 as
a two-day spirited Sports Extravaganza with great enthusiasm and fervour. The school
ground was all set to welcome the dignitaries and parents on both the days.<br/>
The Day-1 of Shikhar on 21 December 2022 was much to the delight of students and
parents. Dr M A Saleem, IPS, Special Commissioner-Bengaluru Traffic Police graced this
grand occasion as the Chief Guest. The students brought in the spirit of sportsmanship in
a grand way. The event commenced with an inspiring invocation song and the bright
sunny day witnessed a plethora of performances such as artistic Yoga, blissful Bhangra,
trendy Zumba, charming Country Dance, refined Aerobics and a finale of myriad sports
duels such as Hockey, Basket Ball and Lawn Tennis. The concluding parade was presented
by the students of March Past along with a marching band who trooped to the metrical
beats and displayed exercises capturing the attention of the audience and presented a
spectacular tribute to the school, making a formation of NPS-10, signifying the mark of 10
glorious years of<i><strong><Typography variant={'Monotype Corsiva'} align={'justify'}> National Public School ,Yeshwanthpur.</Typography></strong></i><br/>
It was a day filled with vibrant energy, enthusiasm and memories to cherish for a long
time. This mega event worked as a medium to channelise the abundant energy of
students in the right direction and helped them discover their interests in outdoor
activities. 
<br></br><br/>
The Day-2 of Shikhar on 22 December 2022 was a day filled with fervour and excitement
experienced amidst thrills, shrills and cheers. The Chief Guest for the day was Ms Sucheta
Deb Burman, an Elite Ultramarathon swimmer.<br/>
The event opened with a glorious and well-synchronised Inter-House March Past, a highly
competitive event where the four houses eyed for the first place. Another highlight of
the day was the lighting of the Torch which was carried by the students who have made
their mark in the National and International Sports Championships. The most
entertaining and fascinating part of the event was the field displays involving mass
student participation which sprinkled on the field an extravaganza of colours and
vibrance, which was a wonderful experience. There were vivid displays such as aesthetic
Yoga, vibrant Rainbow Dance, energetic Dumbbell Drill, synchronised Formation Drill,
skilled Basket Ball Drill, captivating Skating performance, rhythmic Flag Dance and
blended Finale Drill.
<br></br><br/>
No programme is complete without musical performances. The day began with a lyrical
Invocation Song and it came to a thrilling conclusion with a powerful Music Band. Santa
Claus also made his cheerful presence felt and delighted the august gathering.
<br></br><br/>
<i><strong> Shikhar 2022 – The Two Day Sports Extravaganza </strong></i> was an immaculate display of
togetherness, passion and excellence; a testament to the values National Public School
Yeshwanthpur is built on.<br/>
As one walked through the familiar brown gates, greeted by all the colours, the pride and
honour of being a part of this institution could not have come at a better time, just as the
school turned 10! 

        </Typography>
      </Box>
      

      <Box>
        <ImageList
          variant="quilted"
          cols={3}
          rowHeight={isMd ? 300 : 200}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              />
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
      The School Management, Principals and Chief Guest for Day-1 Dr M A Saleem, IPS, Special Commissioner-Bengaluru Traffic Police 
<br/>
        </Typography>
    <Ph1/>
    <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
    The School Management, Principals and Chief Guest for Day-2 Ms Sucheta Deb Burman, Elite Ultramarathon Swimmer
<br/>
        </Typography>
    <Ph2/>
    <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
   Moving to the beat... what a splendid treat!
<br/>
        </Typography>
        <Ph3 />
        <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
  Strength, endurance, precision and perseverance... A feisty galore!
<br/>
        </Typography>

<Ph4/>
<Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
 Blink,... you miss! Pause,... that’s sure for a blaring applause!
<br/>
        </Typography>

    </Grid>
    <Grid item xs={12} md={4}>
             
             <Box marginBottom={4}>
               <SideBarT />
             </Box>
          
           {/* <SidebarNewsletter /> */}
         </Grid>
    </Grid> 
    </Container>
    </Main>
   
  );
};

export default Shikar2022;